var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"paging"},[_c('page-share',{attrs:{"message":_vm.message}}),_vm._v(" "),_c('list-control',{attrs:{"list-name":"BACK TO ALL","list":_vm.$link.storyPage(),"next":_vm.next,"prev":_vm.prev}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }